import { render, staticRenderFns } from "./p-countryAndBudgetVal.vue?vue&type=template&id=0cb1d695&scoped=true"
import script from "./p-countryAndBudgetVal.vue?vue&type=script&lang=js"
export * from "./p-countryAndBudgetVal.vue?vue&type=script&lang=js"
import style0 from "./p-countryAndBudgetVal.vue?vue&type=style&index=0&id=0cb1d695&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb1d695",
  null
  
)

export default component.exports